import { render, staticRenderFns } from "./DatasetImportPopup.vue?vue&type=template&id=e5387998&scoped=true"
import script from "./DatasetImportPopup.vue?vue&type=script&lang=js"
export * from "./DatasetImportPopup.vue?vue&type=script&lang=js"
import style0 from "./DatasetImportPopup.vue?vue&type=style&index=0&id=e5387998&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5387998",
  null
  
)

export default component.exports